export default class DtoMatEventsType {
    constructor(obj) {
        this.id = obj.id // Long,
        this.referenceCode = obj.referenceCode // Option[Long],
        this.name = obj.name // String,
        this.updateLogin = obj.updateLogin // Option[String],
        this.updateDate = obj.updateDate // Option[DateTime]
    }
}